var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import { withRouter } from 'react-router';
import { compose, getContext, withProps } from 'recompose';
import { Login } from '@indica-labs/cmp-login';
import { StyledLoginForm, StyledLoginPage } from './style';
var Page = function (props) { return (React.createElement(StyledLoginPage, null,
    React.createElement(StyledLoginForm, null,
        React.createElement(Login, __assign({}, props))))); };
export default compose(withRouter, getContext({ config: PropTypes.object }), withProps(function (_a) {
    var config = _a.config, history = _a.history;
    return ({
        loginMethods: config.loginMethods,
        saveToken: function (token) {
            sessionStorage.setItem('authnToken', token);
            history.push({ pathname: '/graphql/workbench' });
        },
        submitCredentials: function (credentials) { return fetch('/token', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                username: credentials.username,
                password: credentials.password,
                authenticationMethod: credentials.loginMethod,
            }),
        })
            .then(function (response) { return response.json(); })
            .then(function (json) { return json.authn; }); },
        handleErrors: function (err) { throw new Error(err); },
    });
}))(Page);
